// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".max-app-width[data-v-617ab0be]{max-width:850px}\n", "",{"version":3,"sources":["webpack://src/components/App.vue"],"names":[],"mappings":"AAAA,gCAAgC,eAAe","sourcesContent":[".max-app-width[data-v-617ab0be]{max-width:850px}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
